export default {
    state: {
        data: 1
    },
    getters: {},
    actions: {
    },
    mutations: {
    }
}